import { Component, Input } from '@angular/core';
// import * as pickUpPointCount from "./routesummary.json";




declare const Chart: any;

@Component({
    selector: 'chartjs-barchart',
    templateUrl: './barchart.html',
    styleUrls: ['./barchart.css']
})



export class BarChart {
    public chart: any;
    public elemId = 'chartjs-canvas-' + Math.random();

    

    @Input() _data: any = {
        labels: ['Completed','pending','intransit','escort'],
        data: [],
        title: []
    }
    @Input() _height: number = 250

    ngOnInit() {
        setTimeout(() => {
            this.loadChart();
        }, 800);


    }
    loadChart() {
        const options = {

            type: "bar",
            data: {

                labels: this._data.labels,
                datasets: [
                    {
                        label: this._data.title,
                        // data: [12, 19, 3, 5, 2, 3,7,8],
                        data: this._data.data,
                        backgroundColor: this._data.data.map(() => "rgb(27, 128, 184)"), //blue
                       
                        borderWidth: 1,
                        barThickness: 16,
                        barPercentage: 0.5,
                    }
                ]
            },
            options: {
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                },
                responsive: true,
                maintainAspectRatio: this._height != 200 ? false : true
            },

        };
        this.chart = new Chart(this.elemId, options);
        // this.chart.setOptions({
        //     responsive: true,
        //     maintainAspectRatio: true
        // });
    }

}
